import { RouteObject } from 'react-router-dom';
import { homeRoutes } from './home';
import { adminRoutes } from './admin';

const routes: RouteObject[] = [...homeRoutes, ...adminRoutes];

export default routes;
